import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//apicall
import { apiCall, METHOD } from '../../constants/baseUrl';
import { CMS_PAGES } from '../../constants/api';
import { HashLink } from 'react-router-hash-link';
class AfterLoginFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tandC: '',
      privarcyPolicy: '',
      aboutUs: '',
      supportEmail: '',
      instagram: '',
      faceBook: '',
      twitter: '',
    };
  }

  componentDidMount() {
    apiCall(
      CMS_PAGES,
      {},
      (data) => {
        this.setState({
          tandC: data.terms_and_conditions,
          privarcyPolicy: data.privacy_policy,
          aboutUs: data.about_us,
          supportEmail: data.support_email,
          instagram: data.instagram_url,
          faceBook: data.facebook_url,
          twitter: data.twitter_url,
        });
      },
      (error) => console.log(error),
      METHOD.GET
    );
  }

  render() {
    const {
      tandC,
      privarcyPolicy,
      aboutUs,
      supportEmail,
      instagram,
      faceBook,
      twitter,
      faqs,
    } = this.state;

    return (
      <footer className="footer_new">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="footer-img-container">
                  <div className="footer-logo mb-4">
                    <img src="/assets/img/logo.svg" height="45px" />
                  </div>
                  <div className="store-icon">
                    <div className="mb-2">
                      <a
                        target="_blank"
                        href="https://apps.apple.com/us/app/id1532588555"
                      >
                        <img src="/assets/img/new/app-store.png" />
                      </a>
                    </div>
                    <div className="mb-2">
                      <a
                        target="_blank"
                        href="https://play.google.com/store/apps/details?id=com.leafgasng.customer"
                      >
                        <img src="/assets/img/new/play-store.png" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <h6 className="mb-3 mt-3 mt-md-0">Cylinder gas</h6>
                <ul className="list-unstyled m-0">
                  <li>
                    <Link to="/">Prices</Link>
                  </li>
                  <li>
                    <Link to="/nearest-dealer">Nearest Dealer</Link>
                  </li>
                  <li>
                    <Link to="/products">Products</Link>
                  </li>
                  <li>
                    <Link to="/cylinder-gas-information">
                      Cylinder Gas information
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-app">Mobile App</Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <h6 className="mb-3 mt-3 mt-md-0">Social Media</h6>
                <ul className="list-unstyled form-row mb-0">
                  <li className="col-sm-6">
                    <a target="_blank" href={faceBook}>
                      <img
                        className="mr-2"
                        src="/assets/img/new/facebook.png"
                      />
                      &nbsp;Facebook
                    </a>
                  </li>
                  <li className="col-sm-6">
                    <a href={instagram} target="_blank">
                      <img
                        className="mr-2"
                        src="/assets/img/new/instagram.png"
                      />
                      &nbsp;Instagram
                    </a>
                  </li>
                  <li className="col-sm-6">
                    <a href={twitter} target="_blank">
                      <img className="mr-2" src="/assets/img/new/twitter.png" />
                      &nbsp;Twitter
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="copyrights">
          <div className="container">
            <div className="form-row">
              <div className="col-md-6 text-center text-md-left">
                <p className="mb-2 mb-md-0">
                  Copyright © 2020, All rights Reserved. |{' '}
                  <a target="_blank" href={aboutUs}>
                    About Us
                  </a>
                </p>
              </div>
              <div className="col-md-6 text-center text-md-right">
                <a target="_blank" href={tandC}>
                  Terms & Conditions
                </a>{' '}
                |
                <a target="_blank" href={privarcyPolicy}>
                  Privacy Policy
                </a>{' '}
                |{' '}
                <Link to="/faqs" href={privarcyPolicy}>
                  FAQs
                </Link>{' '}
                |
                <HashLink
                  to="/contact-us"
                  scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })}
                >
                  {' '}
                  Contact Us
                </HashLink>
              </div>
            </div>
          </div>
        </div>
      </footer>
      // <footer className="sticky-footer">

      // </footer>
    );
  }
}

export default AfterLoginFooter;
